import React from 'react';
import './Sub-services.css';
import tramites from './assets/Tramites.png';

const TramitesOperador = () => {
  return (
    <div className="container">
      <h2>Trámites ante el operador de red</h2>
      <p>
        Los trámites ante el operador de red incluye toda la gestión
        administrativa y documental requeridos para formalizar diferentes
        proceso como: solicitud de disponibilidad del servicio, factibilidades,
        estudios de conexión para nuevas cargas o generación; aprobación de
        diseños eléctricos, legalización de plantas de generación eléctrica,
        solicitud de instalación o cambio de medidor (monofásico, trifásico o
        bidireccional); coordinación y acompañamiento en pruebas de conexión y
        verificación técnica, trámite de ampliación de carga instalada,
        modificaciones por cambio de uso o propietario; trámite de retiro o
        corte definitivo de instalaciones eléctricas, entre otros.
      </p>
      <img src={tramites} alt="Imagen sobre tramites ante el operador de red" />
      <p>
        Ofrecemos el servicio integral de acompañamiento administrativo en la
        tramitología ante el operador de red, dando cumplimiento a la normativa
        vigente y la correcta conexión, modificación o legalización de
        instalaciones eléctricas en proyectos residenciales, comerciales,
        industriales y de generación.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Cumplimiento legal y técnico total.</li>
        <li>Mayor agilidad y eficiencia en los procesos.</li>
        <li>Seguridad y tranquilidad para el cliente.</li>
        <li>Ahorro de tiempo y recursos.</li>
      </ul>
    </div>
  );
};

export default TramitesOperador;
